"use strict"
/**
 * @Desc: 测试环境动态配置
 * @Author: zuozuo
 * @Date: 2017-02-27
 */
module.exports = {
    debug : false,
    API_BASE_URL:'',
    OPEN_URL:'https://open.pixiugj.com',
	MP_URL:'https://mp.pixiugj.com'
}



// WEBPACK FOOTER //
// ./src/config.js